import env from 'global/environments'

import { history } from "app-history"
import { store } from 'redux/storeConfig/store'

import { appUpdateRole, appToggleAuthenticated } from 'redux/actions/app'

import { platformVpFetchProfile, platformVpFetchExperiences, platformVpFetchEducations, platformVpFetchReferences } from 'redux/actions/platform/vp'
import { platformEnterpriseFetchListings, platformEnterpriseFetchAlias } from 'redux/actions/platform/enterprise'
import { platformVtFetchProfile, platformVtFetchMembers, platformVtFetchReferences } from 'redux/actions/platform/vt'
import { platformTeamsFetchListings, platformTeamsFetchAlias } from 'redux/actions/platform/teams'

export const formUpdateActiveId = (data) => {
  return dispatch => dispatch({ type: "FORM_UPDATE_ACTIVE_ID", data })
}

export const formUpdateActiveAction = (data) => {
  return dispatch => dispatch({ type: "FORM_UPDATE_ACTIVE_ACTION", data })
}

export const formUpdateInitialValue = (data) => {
  return dispatch => dispatch({ type: "FORM_UPDATE_INITIAL_VALUE", data })
}

export const formToggleModalActive = (data) => {
  return dispatch => dispatch({ type: "FORM_TOGGLE_MODAL_ACTIVE", data })
}

export const formUpdateWizardPage = (data) => {
  return dispatch => dispatch({ type: "FORM_UPDATE_WIZARD_PAGE", data })
}

export const formToggleLoading = (data) => {
  return dispatch => dispatch({ type: "FORM_TOGGLE_LOADING", data })
}

export const formUpdateSuccess = (data) => {
  return dispatch => dispatch({ type: "FORM_UPDATE_SUCCESS", data })
}

export const formUpdateError = (data) => {
  return dispatch => dispatch({ type: "FORM_UPDATE_ERROR", data })
}

export const formSubmitAuthenticated = (serverCall) => {
  return async (dispatch) => {
    store.dispatch(formToggleLoading(true))
    store.dispatch(formUpdateError(null))

    const response = await serverCall()

    const validId = /[0-9A-Fa-f]{24}/g

    const { email, message, resetPasswordToken } = response
    let registerApply;
    if (response.apply) {
      registerApply = response.apply.data;
    }

    if (message === true || validId.test(message) || registerApply === true) {
      store.dispatch(formUpdateSuccess(message))
      store.dispatch(appUpdateRole('user'))
      store.dispatch(appToggleAuthenticated(true))
    } else if (resetPasswordToken) {
      history.push(`/auth-force-reset?email=${email}&resetPasswordToken=${resetPasswordToken}`)
    } else {
      store.dispatch(formUpdateError(message))
    }
    
    store.dispatch(formToggleLoading(false))
  }
}

export const formSubmit = (serverCall) => {
  return async () => {
    store.dispatch(formToggleLoading(true))
    store.dispatch(formUpdateError(null))
  
    const response = await serverCall()

    const { message, error } = response
  
    if (!error) {
      store.dispatch(formUpdateSuccess(message))
      formRefreshAfterUpdate()
      store.dispatch(formToggleLoading(false))
      return true
    } else {
      store.dispatch(formUpdateError(message))
      store.dispatch(formToggleLoading(false))
      return false
    }
  }
}

export const formDismissModal = () => {
  return async () => {
    store.dispatch(formUpdateActiveId(null))
    store.dispatch(formUpdateInitialValue(null))
    store.dispatch(formToggleModalActive(false))
  }
}

export const formRefreshAfterUpdate = () => {
  const { form: { activeId } } = store.getState()

  // VP
  if (env.platform === 'vp') {
    if (activeId === 'profile') store.dispatch(platformVpFetchProfile())
    else if (activeId === 'experience') store.dispatch(platformVpFetchExperiences())
    else if (activeId === 'education') store.dispatch(platformVpFetchEducations())
    else if (activeId === 'reference' || activeId === 'reference-view') store.dispatch(platformVpFetchReferences())
  // VT
  } else if (env.platform === 'vt') {
    if (activeId === 'profile') store.dispatch(platformVtFetchProfile())
    else if (activeId === 'member') store.dispatch(platformVtFetchMembers())
    else if (activeId === 'reference' || activeId === 'reference-view') store.dispatch(platformVtFetchReferences())
  // ENTERPRISE
  } else if (env.platform === 'enterprise') {
    if (activeId === 'listing') store.dispatch(platformEnterpriseFetchListings())
    else if (activeId === 'alias') store.dispatch(platformEnterpriseFetchAlias())
  // TEAMS
  } else if (env.platform === 'teams') {
    if (activeId === 'listing') store.dispatch(platformTeamsFetchListings())
    else if (activeId === 'alias') store.dispatch(platformTeamsFetchAlias())
  }
}
